//选科
import React, { useState, useEffect } from 'react';
import { Cascader, message } from 'antd';
import styles from './optional1.module.scss';
import setRequiredFields from './GaokaoxkStore'
import { SVGPureIcon } from "@/ui";
import { observer } from 'mobx-react-lite';

const options = [
  {
    value: '物理',
    label: '物理',
    province: ['北京', '上海', '天津', '重庆', '山东', '山西', '河南', '河北', '湖北', '湖南', '江西', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '广东', '广西', '四川', '陕西', '甘肃', '海南', '贵州', '内蒙古', '云南', '青海', '宁夏']
  },
  {
    value: '化学',
    label: '化学',
    province: ['北京', '上海', '天津', '重庆', '山东', '山西', '河南', '河北', '湖北', '湖南', '江西', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '广东', '广西', '四川', '陕西', '甘肃', '海南', '贵州', '内蒙古', '云南', '青海', '宁夏']
  },
  {
    value: '生物',
    label: '生物',
    province: ['北京', '上海', '天津', '重庆', '山东', '山西', '河南', '河北', '湖北', '湖南', '江西', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '广东', '广西', '四川', '陕西', '甘肃', '海南', '贵州', '内蒙古', '云南', '青海', '宁夏']
  },
  {
    value: '历史',
    label: '历史',
    province: ['北京', '上海', '天津', '重庆', '山东', '山西', '河南', '河北', '湖北', '湖南', '江西', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '广东', '广西', '四川', '陕西', '甘肃', '海南', '贵州', '内蒙古', '云南', '青海', '宁夏']
  },
  {
    value: '地理',
    label: '地理',
    province: ['北京', '上海', '天津', '重庆', '山东', '山西', '河南', '河北', '湖北', '湖南', '江西', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '广东', '广西', '四川', '陕西', '甘肃', '海南', '贵州', '内蒙古', '云南', '青海', '宁夏']
  },
  {
    value: '政治',
    label: '政治',
    province: ['北京', '上海', '天津', '重庆', '山东', '山西', '河南', '河北', '湖北', '湖南', '江西', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '广东', '广西', '四川', '陕西', '甘肃', '海南', '贵州', '内蒙古', '云南', '青海', '宁夏']
  },
  {
    value: '技术',
    label: '技术',
    province: ['浙江']
  },
  {
    value: '理科',
    label: '理科',
    province: ['新疆', '西藏']
  },
  {
    value: '文科',
    label: '文科',
    province: ['新疆', '西藏']
  }
];

const Optional = (props) => {
  const { areaName } = props;
  const [selectedValues, setSelectedValues] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [maxCount, setMaxCount] = useState(3); // 默认最大数量为3
// 新增状态，用于控制文字颜色
  
  const warningActive=setRequiredFields.warningActive
  // 根据地区设置最大可选数量
  useEffect(() => {
    if (!areaName) return;

    // 最大可选数为3的地区
    const threeAreas = ['北京', '上海', '海南', '天津', '山东', '浙江'];

    // 最大可选数为2的地区
    const twoAreas = [
      '安徽', '重庆', '福建', '甘肃', '广东', '广西', '贵州', '黑龙江',
      '河北', '河南', '湖北', '湖南', '江苏', '江西', '吉林', '辽宁',
      '内蒙古', '宁夏', '青海', '山西', '陕西', '四川', '云南'
    ];

    // 最大可选数为1的地区
    const oneAreas = ['新疆', '西藏'];

    if (threeAreas.includes(areaName)) {
      setMaxCount(3);
    } else if (twoAreas.includes(areaName)) {
      setMaxCount(2);
    } else if (oneAreas.includes(areaName)) {
      setMaxCount(1);
    } else {
      setMaxCount(3); // 默认值
    }

    // 当地区变化时清空已选科目
    setSelectedValues([]);
  }, [areaName]);

  const onChange = (value) => {
    // 检查是否超过最大可选数量
    if (value.length > maxCount) {
      setShowWarning(true);
      setTimeout(() => setShowWarning(false), 2000);
      message.warning(`最多只能选择${maxCount}个科目`);
      return;
    }

    setSelectedValues(value);
    setShowWarning(false);
    setRequiredFields.setWarningActive(false); // 重置警告状态

    setRequiredFields.setRequiredFields({
      optional: value.flatMap(subArr => subArr[0] ? [subArr[0]] : []), // 更新 optional 属性
      maxCount: maxCount, // 更新 maxCount 属性
    });
    setRequiredFields.setOptionalFields({
      optional: value
    });
    setRequiredFields.setOptionalFields({
      province: maxCount === 1 ? value[0] : '综合'
    });

    // 当选择数量达到最大值时关闭下拉框
    if (value.length === maxCount) {
      setDropdownVisible(false);
    }
  };

  const handleDropdownVisibleChange = (visible) => {
    if (visible) {
      setDropdownVisible(true);
    } else {
      setDropdownVisible(false);

      // 检查选择数量是否达到要求
      if (selectedValues.length < maxCount) {
        if(setRequiredFields.optionalFields.optional?.length!==maxCount){
          setRequiredFields.setWarningActive(true);
        }
         // 激活警告状态
        message.warning(`请选择${maxCount}个科目`);
      }
    }
  };

  const dropdownRender = (menus) => (
    <div className="custom-dropdown-container" >
      <div
        className={`selection-hint ${selectedValues.length === maxCount ? 'completed' : ''}`}
        style={{
          padding: '10px 0 0 10px',
          fontSize: '12px',
          color: '#00000080' // 黑色透明度50%的颜色值
        }}
      >
        {`必选${maxCount}个（${selectedValues.length}/${maxCount}）`}
      </div>
      {menus}
    </div>
  );

  const tagRender = (props) => {
    const { label, closable, onClose } = props;

    const handleClose = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const optionalList=setRequiredFields?.optionalFields?.optional   
    const flattenedData = optionalList?.map(item => item[0]);         
    return (
      <span className="custom-tag" style={{ color: warningActive ? '#FF2828' : '#006AFF', fontWeight: 700 }}>
        {label}
        {closable && optionalList?.length > 1 && flattenedData?.indexOf(label) !== flattenedData?.length - 1 && (
        <span className="tag-close-icon" onClick={handleClose}>
          、
        </span>
      )}
      </span>
    );
  };
  

  // 过滤出当前地区可选的科目
  const filteredOptions = options.filter(option =>
    option.province.includes(areaName)
  );

  return (
    <div>
      <Cascader
        className={styles['custom-cascader']}
        popupClassName={styles['custom-cascader-dropdown']}
        style={{
          width: 'auto', // 关键：设置为 auto
          minWidth: 78, // 保留最小宽度
          display: 'inline-block' // 确保宽度自适应
          
        }}
        multiple
        allowClear={false}
        placeholder="选科"
        options={filteredOptions}
        value={setRequiredFields.optionalFields.optional}
        onChange={onChange}
        open={dropdownVisible}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        dropdownRender={dropdownRender}
        tagRender={tagRender}
        maxTagCount={2}
        maxTagPlaceholder={(omittedValues) => (
          <span style={{ color: '#006AFF' }}>
            ...
          </span>
        )}
         // 自定义选择器右侧的下拉箭头
              suffixIcon={
                <SVGPureIcon
                name={dropdownVisible?"shangjant":"ArrowDown"}
                  className=''
                  style={{ width: 16, height: 16 }}
                />
              }
        
              // 自定义下拉菜单中的展开箭头
              expandIcon={
                (
                  <SVGPureIcon
                    name="ArrowRight"
                    className='text-black text-opacity-50'
                    style={{
                      width: 16,
                      height: 16,
                    }}
                  />
                )
              }
              optionRender={(option, state = {}) => {
                const huoquxuanz=setRequiredFields?.requiredFields?.optional                
                
                return (
                  <div style={{color:huoquxuanz?.includes(option?.label)?"#006AFF":''}}>
                     {option?.label}
                  </div>
                );
              }}
      />
    </div>
  );
};

export default observer(Optional);